import moment from 'moment';

const checkDateExists = (date) => !!date;
const checkDateTodayOrLater = (date) => !moment().isAfter(date, 'day');

export const checkDate = (date) => {
  if (!checkDateExists(date)) { return { error: 'Обязательное поле для ввода' }; }
  // if(!checkDateTodayOrLater(date))
  //   return { error: 'Дата должна быть не ранее текущей даты' }
  return { error: null };
};

export const checkDatesPair = (startDate, endDate, errMsg) => {
  if (moment(startDate).isAfter(endDate, 'day')) { return { error: errMsg || 'Дата начала должна быть раньше даты окончания' }; }
  return { error: null };
};

export const checkDatesFull = (startDate, endDate) => {
  const checkStartDate = checkDate(startDate);
  const checkEndDate = checkDate(endDate);
  const checkBothDates = checkDatesPair(startDate, endDate);

  return checkStartDate.error || checkEndDate.error || checkBothDates.error;
};
